import { useEffect } from 'react';

import { useErrorHandler } from 'src/services';
import { useBrandBriefsActions } from 'src/store/brandBriefs';

export const usePreloadBrandBriefs = (brandVoice) => {
  const handleError = useErrorHandler();
  const brandBriefsActions = useBrandBriefsActions();

  useEffect(() => {
    const fetchBriefs = async () => {
      try {
        await brandBriefsActions.queryBrandBriefs(brandVoice.id);
      } catch (error) {
        handleError(error);
      }
    };

    if (brandVoice?.id) {
      fetchBriefs();
    }
  }, [brandVoice, handleError, brandBriefsActions]);
};
